import React, { Component } from 'react';
import { connect } from 'react-redux';
import KeywordDensity from '../KeywordDensity'
import { Row, Icon, Col } from 'react-materialize';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import * as actions from '../../../actions';
import { get_pixel_width } from '../../../helpers';
import './style.css';

class SerpPreview extends Component {
  constructor(props) {
    super(props);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleH1Change = this.handleH1Change.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  componentDidMount() {
    const { $ } = window;
    $('.tooltipped').tooltip({ delay: 50 });
  }

  shouldComponentUpdate(nextProps) {
    const titleChanged = nextProps.titleTag !== this.props.titleTag;
    const descriptionChanged =
      nextProps.metaDescription !== this.props.metaDescription;
    const pageChanged = nextProps.selectedPage !== this.props.selectedPage;
    const h1Changed = nextProps.h1 !== this.props.h1;
    const copiedChanged = nextProps.copyToast !== this.props.copyToast;

    return (
      titleChanged ||
      descriptionChanged ||
      pageChanged ||
      h1Changed ||
      copiedChanged
    );
  }

  handleTitleChange(event) {
    const input = event.target.value;
    const charLen = input.length;
    const pixelWidth = get_pixel_width(input);

    if (pixelWidth > 600) return false;
    this.props.fetchTitleTag({ input, charLen });
  }

  handleDescriptionChange(event) {
    const input = event.target.value;
    const charLen = input.length;
    if (charLen > 160) return false;

    this.props.fetchMetaDescription({ input, charLen });
  }

  handleH1Change(event) {
    this.props.fetchH1(event.target.value);
  }

  componentWillReceiveProps(nextProps) {
    const nextCopyToast = nextProps.copyToast;
    const currCopyToast = this.props.copyToast;

    const queryPage = nextProps.selectedQuery;
    const sitePage = nextProps.selectedPage;
    const differentSite = nextProps.selectedSite !== this.props.selectedSite;
    const diffQuery = queryPage !== this.props.selectedQuery;

    if (nextCopyToast !== currCopyToast) {
      window.Materialize.toast(nextCopyToast, 500);
      return this.props.checkIfCopied(null);
    }

    if (differentSite) {
      this.props.fetchKeywordDensity();
      this.props.fetchPageMeta();
      this.props.selectPage();
    }

    if (sitePage !== this.props.selectedPage) {
      this.props.fetchPageMeta(sitePage);
      this.props.fetchKeywordDensity();
    }

    if (diffQuery && queryPage !== '') {
      this.props.fetchPageMeta(sitePage);
    }

    if (queryPage === '' && diffQuery) {
      this.props.fetchKeywordDensity();
      return;
    }

    if (queryPage !== this.props.selectedQuery) {
      this.props.fetchKeywordDensity({ sitePage, queryPage });
    }
  }

  handleCopy(type) {
    this.props.checkIfCopied(type);
  }

  render() {
    const { titleTag, selectedPage, metaDescription, h1 } = this.props;
    return (
      <div className="page-meta">
        <div className="serp-header">{titleTag}</div>
        <div className="serp-url">{selectedPage}</div>
        <div className="serp-description">{metaDescription}</div>
        <Row>
          <div className="input-field col s4 m6 l6">
            <input value={titleTag} onChange={this.handleTitleChange} />
            <label className="active">Title</label>
          </div>
          <Col>
            <CopyToClipboard
              onCopy={this.handleCopy.bind(null, 'title')}
              text={titleTag}
            >
              <div
                data-position="top"
                data-delay="50"
                data-tooltip="copy title tag"
                className="tooltipped center-align waves-effect waves-teal btn-flat content-copy_btn"
              >
                <Icon>content_copy</Icon>
              </div>
            </CopyToClipboard>
          </Col>
          <Col style={{ height: 46 }} className="valign-wrapper">
            {this.props.titleLength + ' chars '} &middot;{' '}
            {' ' + get_pixel_width(titleTag) + ' pixels'}
            <span
              className="tooltipped"
              data-position="top"
              data-delay="50"
              data-tooltip="600 max pixels"
            >
              <Icon tiny>info_outline</Icon>
            </span>
          </Col>
        </Row>
        <Row>
          <div className="input-field col s4 m6 l6">
            <input
              value={metaDescription}
              onChange={this.handleDescriptionChange}
            />
            <label className="active">Meta Description</label>
          </div>
          <Col>
            <CopyToClipboard
              onCopy={this.handleCopy.bind(null, 'description')}
              text={metaDescription}
            >
              <div
                data-position="top"
                data-delay="50"
                data-tooltip="copy meta description"
                className="tooltipped center-align waves-effect waves-teal btn-flat content-copy_btn"
              >
                <Icon>content_copy</Icon>
              </div>
            </CopyToClipboard>
          </Col>
          <Col style={{ height: 46 }} className="valign-wrapper">
            {this.props.metaDescLen + ' chars '} &middot;{' '}
            {' ' + get_pixel_width(metaDescription) + ' pixels'}
            <span
              className="tooltipped"
              data-position="top"
              data-delay="50"
              data-tooltip="160 max characters"
            >
              <Icon tiny>info_outline</Icon>
            </span>
          </Col>
        </Row>
        <Row>
          <div className="input-field col s9 m6 l6">
            <input value={h1} onChange={this.handleH1Change} />
            <label className="active">H1</label>
          </div>
          <Col>
            <CopyToClipboard onCopy={this.handleCopy.bind(null, 'h1')} text={h1}>
              <div
                data-position="top"
                data-delay="50"
                data-tooltip="copy h1"
                className="tooltipped center-align waves-effect waves-teal btn-flat content-copy_btn">
                {' '}
                <Icon>content_copy</Icon>
              </div>
            </CopyToClipboard>
          </Col>
          <Col>
            <KeywordDensity />
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps({
  titleTag,
  metaDescription,
  selectedPage,
  h1,
  copyToast,
  titleLength,
  metaDescLen,
  selectedQuery,
  selectedSite
}) {
  return {
    titleTag,
    metaDescription,
    selectedPage,
    h1,
    copyToast,
    titleLength,
    metaDescLen,
    selectedQuery,
    selectedSite
  };
}

export default connect(mapStateToProps, actions)(SerpPreview);



// WEBPACK FOOTER //
// ./src/components/Dashboard/SerpPreview/index.js